export const ChartTypes = {
    SUBURB_TEN_YEARS_TREND: 1,
    SUBURB_HALF_YEAR_AUCTION_TREND: 2,
};
